/**
 * Enum kho bạc duyệt
 * dqvinh 24.11.2022
 */
export default {
  NotApproved: 0,
  Approved: 1,
};
